<template>
  <cycle-radio-group
    v-model="model"
    class="opc-card-radio"
    :plans="currentPlans"
    :action="switchBillingCycle"
    :aria-label="`${planEnName} Billing Cycle`"
  >
    <zm-tooltip
      v-for="{ disabled, disabledTooltip, plan } in billingCycleList"
      :key="plan.billing_cycle"
      :disabled="!disabledTooltip"
    >
      <div slot="content" v-html="disabledTooltip" />
      <zm-radio
        :data-testid="radioTestId ? radioTestId : `checkout-radio-billing-cycle-${plan.billing_cycle}`"
        :label="plan.billing_cycle"
        :disabled="disabled"
        class="opc-billing-cycle__radio"
      >
        <p class="opc-zmone__radio-title text-capitalize">
          {{ $t(`billing.billing_cycle.${plan.billing_cycle}`) }}
          <CycleCurrentBadge :value="plan" />
        </p>
        <p class="opc-product-price-container" tabindex="-1" :aria-label="ariaPriceOfMonthForLabel(plan)">
          <span
            v-for="(value, key, index) in getPriceOfMonth(plan.amount, plan.billing_cycle, { forceDiff: true })"
            :key="index"
            :class="[
              `opc-product-price-container__${key}`,
              useSmallSize(value) ? 'opc-product-price-container__small' : '',
            ]"
            :style="value.symbol && value.place === 'end' ? { order: 1 } : {}"
            aria-hidden="true"
          >
            {{ value.symbol ? value.symbol : value }}
          </span>
        </p>
        <p v-if="isTrial" class="opc-zmone__radio-price-unit opc-price-bill-text">
          <span v-html="$t('billing.trial.unit_suffix', [getMergedBilledText(plan.billing_cycle, plan.amount, unit)])"></span><priceVATTip />
        </p>
        <p v-else class="opc-zmone__radio-price-unit opc-price-bill-text">
          <span v-html="getMergedBilledText(plan.billing_cycle, plan.amount, unit)"></span><priceVATTip />
        </p>
      </zm-radio>
    </zm-tooltip>
  </cycle-radio-group>
</template>

<script>
import { get } from 'lodash';
import { BillingCycleEnum, BILLING_CYCLE } from '@/common/constants';
import { getPlanUnitWithCycle } from '@/common/product-unit';
import discountedMonthPrice from '@/common/mixin/discounted-month-price';
import { translateToEn } from '@/plugins/i18n';
import CycleCurrentBadge from '@/components/service/config-billing-cycle/cycle-current-badge.vue';

export default {
  name: 'BilledBillingCycleRadio',
  mixins: [discountedMonthPrice],
  components: {
    CycleCurrentBadge,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    /**
     * [
     *  {
     *    plan: {
     *      amount: number,
     *      billing_cycle: string,
     *      cycleValue: number,
     *      ...,
     *    },
     *    disabled: boolean,
     *    disabledTooltip: string,
     *  }
     * ]
     */
    billingCycleList: {
      type: Array,
      default: () => [],
      required: true,
    },
    unit: {
      type: Number,
    },
    radioTestId: {
      type: String,
    },
    isTrial: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      BillingCycleEnum,
      BILLING_CYCLE,
      getPlanUnitWithCycle,
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    currentPlans() {
      return this.billingCycleList.map((l) => l.plan);
    },
    planEnName() {
      return translateToEn(get(this.currentPlans, [0, 'typeNameKey']));
    }
  },
  methods: {
    switchBillingCycle(oldPlan, newPlan) {
      this.$emit('change', oldPlan, newPlan);
    },
  },
};
</script>

<style lang="scss" scoped>
.opc-billing-cycle {
  &__radio {
    flex-grow: 1;
    width: 100%;
    ::v-deep .zm-radio {
      &__wrap {
        width: 100%;
      }
      &__label {
        &--inner {
          width: 100%;
        }
        &.is-disabled {
          .opc-zmone__radio-title, .opc-zmone__radio-price, .opc-zmone__radio-price-unit {
            color: #9191A4 !important;
          }
        }
      }
    }
  }
}
</style>
